import { ShippingRateTerritorialScope } from './shipping-rate-territorial-scope';

export class OriginShippingRate {
    public scope?: ShippingRateTerritorialScope;
    public countryId: number = 0;
    public stateIds: number[] = [];
    public postalCodes: string[] = [];

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(
            this,
            json,
            {
                stateIds: json.stateIds ? json.stateIds.map((stateId: number) => stateId) : [],
                postalCodes: json.postalCodes ? json.postalCodes.map((postalCode: string) => postalCode) : [],
            });
    }

    public clone(): OriginShippingRate {
        const origin: OriginShippingRate = new OriginShippingRate();

        origin.scope = this.scope;
        origin.countryId = this.countryId;
        origin.stateIds = this.stateIds;
        origin.postalCodes = this.postalCodes;

        return origin;
    }
}
